var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flag == _vm.index && _vm.detailShow
    ? _c(
        "div",
        {
          staticClass: "threads-box team-transferth-box",
          attrs: { id: "threadsBox" }
        },
        _vm._l(_vm.syncItem.sources, function(itemSyncDetail, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "thread-box",
              class: [_vm.collapseIndex == index ? "collapse-thread-box" : ""],
              style: {
                height:
                  _vm.collapseIndex == index
                    ? _vm.getHeight(itemSyncDetail.syncDetail) + "px"
                    : ""
              }
            },
            [
              _c("div", { staticClass: "thread-all-backgroud" }, [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        itemSyncDetail.syncDetail.state2 &&
                        itemSyncDetail.syncDetail.state2.percent &&
                        itemSyncDetail.syncDetail.state2.percent != 100,
                      expression:
                        "itemSyncDetail.syncDetail.state2&&itemSyncDetail.syncDetail.state2.percent&&itemSyncDetail.syncDetail.state2.percent!=100"
                    }
                  ],
                  staticClass: "thread-all-back",
                  style: {
                    width: itemSyncDetail.syncDetail.state2.percent + "%"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "thread-detail-bottom" },
                [
                  _c("div", { staticClass: "business-thread-name" }, [
                    _c("div", { staticStyle: { float: "left" } }, [
                      _vm._v(_vm._s(_vm.$t("language.common.from")) + ": ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "thread-catelog",
                        attrs: {
                          title: itemSyncDetail.syncDetail.state2.sourceFilename
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toSourceCatalog(itemSyncDetail)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            itemSyncDetail.syncDetail.state2.sourceFilename
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "business-thread-name" }, [
                    _c("div", { staticStyle: { float: "left" } }, [
                      _vm._v(_vm._s(_vm.$t("language.common.to")) + ": ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "thread-catelog",
                        attrs: {
                          title: itemSyncDetail.syncDetail.state2.desFilename
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toAimCatalog(itemSyncDetail)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(itemSyncDetail.syncDetail.state2.desFilename)
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "thread-status" }, [
                    _vm.showStatus(itemSyncDetail) == "threadPercent"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(itemSyncDetail.syncDetail.state2.percent) +
                                "%"
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(itemSyncDetail) == "threadFailure"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.failure")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(itemSyncDetail) == "particalStatus"
                      ? _c(
                          "div",
                          { staticClass: "thread-status-name partical-color" },
                          [_vm._v(_vm._s(_vm.$t("language.common.patial")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(itemSyncDetail) == "threadSuccess"
                      ? _c(
                          "div",
                          { staticClass: "thread-status-name color-green" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("language.common.success"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(itemSyncDetail) == "threadWaiting"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.common.waiting")) + "..."
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(itemSyncDetail) == "threadCancel"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.canceled")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(itemSyncDetail) == "threadCount"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("language.common.countFiles")) +
                              ":(" +
                              _vm._s(
                                itemSyncDetail.syncDetail.state2
                                  .readyFindFileCount
                              ) +
                              _vm._s(_vm.$t("language.common.transferFiles")) +
                              "," +
                              _vm._s(
                                _vm._f("formatByte")(
                                  itemSyncDetail.syncDetail.state2.totalBytes
                                )
                              ) +
                              ")"
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "icon-util  white-up-position",
                    class:
                      _vm.collapseIndex == index ? "purple-down" : "white-up",
                    on: {
                      click: function($event) {
                        return _vm.collapsePage(index, itemSyncDetail)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "thread" } }, [
                    _vm.collapseIndex == index
                      ? _c(
                          "div",
                          {
                            class: _vm.isVip()
                              ? "sync-threads-vip"
                              : "sync-threads-detail"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "thread-detail" },
                              [
                                _c("syncThreadDetail", {
                                  ref: "syncThreadDetail",
                                  refInFor: true,
                                  attrs: {
                                    flag: _vm.collapseIndex,
                                    index: index,
                                    detailShow: _vm.itemDetailShow,
                                    threadChange: _vm.threadChange,
                                    itemSyncDetail: itemSyncDetail
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46d58abb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d58abb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_businessTransfer_threads.vue
// module id = null
// module chunks = 